import { render, staticRenderFns } from "./ExSection.vue?vue&type=template&id=7fa62ba8&scoped=true&"
import script from "./ExSection.vue?vue&type=script&lang=js&"
export * from "./ExSection.vue?vue&type=script&lang=js&"
import style0 from "./ExSection.vue?vue&type=style&index=0&id=7fa62ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa62ba8",
  null
  
)

export default component.exports